import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import Button from "../../shared/button/Btn";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import PageTopTitle from "../../shared/PageTopTitle";
import { useScrollLock } from "../../../hooks/useScrollLock";
import { showNestedModal } from "../../../features/modal/modalSlice";

const Container = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;

  .modal {
    width: 800px;
    height: 500px;
    color: ${({ theme }) => theme.mainTextColor};
    background-color: ${({ theme }) => theme.mainBgColor};
    border-radius: 10px;
    padding-top: 20px;
    overflow: auto;
    .titles {
      padding-inline: 60px;
      margin-top: 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      text-align: center;
      p {
        width: 140px;
        font-size: var(--font-size-md);
        font-weight: var(--font-weight-lg);
        text-decoration: underline;
      }
    }
    .text-box {
      margin-top: 20px;
      padding-inline: 30px;
      min-height: 300px;
      .trucks {
        display: flex;
        align-items: center;
        justify-content: space-between;
        background-color: var(--color-light);
        margin-block: 10px;
        padding-block: 10px;
        border-radius: 10px;
        position: relative;
        padding-inline: 30px;

        p {
          font-size: var(--font-size-sm);
          font-weight: var(--font-weight-md);
          text-align: center;
          width: 140px;
        }
        .delete {
          position: absolute;
          top: 10px;
          right: 10px;
          font-size: 15px;
          color: var(--color-main);
          cursor: pointer;
        }
      }
    }
    .btns {
      display: flex;
      align-items: center;
      margin-top: 25px;
      width: 100%;
      padding-inline: 50px;
      justify-content: center;
      position: sticky;
      bottom: 0;
      background-color: white;
      height: 60px;
      button {
        margin-right: 10px;
        width: auto;
      }
    }
  }
`;

const RegularVehicleListModal = () => {
  const { modalLocation } = useSelector((state) => state.modal);
  const dispatch = useDispatch();
  const location = useLocation();
  const { lockScroll, unlockScroll } = useScrollLock();
  const { regularDriversAllRegularVehicles } = useSelector((state) => state.driversVehicles);

  //! bu modal açıldığnda ekran ı lock lamak için
  useEffect(() => {
    lockScroll();

    return () => {
      unlockScroll();
    };
  }, [lockScroll, unlockScroll]);

  //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
  useEffect(() => {
    if (location.pathname !== modalLocation) {
      dispatch(showNestedModal(null));
    }
  }, [dispatch, location.pathname, modalLocation]);
  
  return (
    <Container onClick={() => dispatch(showNestedModal(null))}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <PageTopTitle isDiffPage title="Devamlı Araçları" />
        <div className="titles">
          <p>Plaka</p>
          <p>Araç</p>
          <p>Referans Durumu</p>
          <p>Tipi</p>
        </div>
        <div className="text-box">
          {regularDriversAllRegularVehicles?.map((item) => (
            <div className="trucks">
              <p>{item?.plate}</p>
              <p>{item?.vehicleType}</p>
              <p>{item?.isReferenceDriver === 1
                ? "Kendi Aracım"
                : "İşverenin Aracı"}</p>
              <p>{item?.truckOrTrailer === 0 ? "Çekici" : "Römork"}</p>
            </div>
          ))}
        </div>
        <div className="btns">
          <Button handleClick={() => dispatch(showNestedModal(null))} width="150px" padding="10px" background="#fff" color={"#E85446"} >
            Kapat
          </Button>
        </div>
      </div>
    </Container>
  );
};

export default RegularVehicleListModal